import c from 'classnames'
import { FiCheck } from 'react-icons/fi'
import Text from '../../atoms/text/Text'
import { VARIANTS } from '../../../types/Components.types'
import styles from './ListSelector.module.css'

export interface IListSelectorOption<T> {
  value: T
  label: string
}

interface IProps<T> {
  options: IListSelectorOption<T>[]
  selectedValue: T
  onSelect: (value: T) => void
  className?: string
}

function ListSelector<T>({ options, selectedValue, onSelect, className }: IProps<T>) {
  return (
    <div className={c(styles.container, className)}>
      {options.map((option, index) => {
        const isActive = selectedValue === option.value
        return (
          <button
            key={index}
            className={c(styles.option, isActive && styles.optionActive)}
            onClick={() => onSelect(option.value)}
          >
            <Text variant={isActive ? VARIANTS.secondary : VARIANTS.max} weight={isActive ? '600' : '400'}>
              {option.label}
            </Text>
            {isActive && <FiCheck className={styles.checkIcon} />}
          </button>
        )
      })}
    </div>
  )
}

export default ListSelector
